<template>
  <div>
    <window-header></window-header>
    <nav-form :onlyIcons="true"></nav-form>
    <section>
      <article style="height: 296px; width:411px">
        <field widget="image" name="imagen" style="position:absolute;width:85px; height:85px; top: 4px; left:6px;" />
        <field name="codigo" widget="input" searchable label="Código" placeholder="Cód." width="67px"
          style="top:9px; left:100px;" :readonly="mode == 'edit'" inputStyle="font-weight:bold;text-align:center;" />
        <field name="descripcion" widget="input" searchable label="Talla" help="Descripcion" placeholder="Descripcion"
          width="270px" style="top:50px; left:100px;" />

        <field name="equivalencias" class="lineas" :htSettings="{
          rowHeights: 15
        }" widget="handsontable" :height="175" :minRows="10" style="top: 105px; left: 6px; width: 399px" :columns="[
          {
            name: 'tamano_mm',
            header: 'Tamaño (mm)',
            help: 'Tamaño en milímetros',
            /*type: 'numeric',
            numericFormat: { pattern: '0,0.00' },*/
          }, {
            name: 'peso_ct',
            header: 'Peso (ct)',
            help: 'Peso en quilates',
            type: 'numeric',
            numericFormat: { pattern: '0,0.000' },
            suffix: ' ct'
          },

        ]" />

      </article>
    </section>
    <v-collapse-wrapper ref="main-collapse" :active="true">
      <div class="header" v-collapse-toggle>
        <div class="item-title">Listado</div>
        <div class="item-after">{{ count }}</div>
      </div>
      <div class="my-content" v-collapse-content>
        <hot-table ref="hotTableComponent" :settings="htSettings"></hot-table>
      </div>
    </v-collapse-wrapper>
  </div>
</template>
<script>
import WindowMixin from "./../components/WindowMixin.vue";
import rFormMixin from "./../components/rFormMixin.vue";
import rTableMixin from "./../components/rTableMixin.vue";
export default {
  mixins: [WindowMixin, rFormMixin, rTableMixin],
  data: function () {
    return {
      title: "Talla",
      dbAdapter: "talla",
      primary: "codigo",
      sequence: { name: "talla" }
    };
  }
};
</script>
